import React from 'react';

const NeoNote = (props) => {
  return (<div className={`nota ${props.extra ? props.extra : ""}`}>
    {props.text}
  </div>);
};

export default NeoNote;